/**
 * tdesign v1.11.1
 * (c) 2025 tdesign
 * @license MIT
 */

import Loading$1 from './Loading.js';
import { LoadingPlugin as LoadingPlugin$1 } from './plugin.js';
import './style/css.js';
import './type.js';
import '../_chunks/dep-8bcc0e9b.js';
import '../_chunks/dep-6b7c7d34.js';
import '../_chunks/dep-248ede8a.js';
import '../_chunks/dep-e0bb3f23.js';
import '../_chunks/dep-a99bb570.js';
import 'react';
import 'classnames';
import '../_util/dom.js';
import 'raf';
import 'lodash-es';
import '../_util/easing.js';
import '../hooks/useConfig.js';
import '../config-provider/ConfigContext.js';
import '../locale/zh_CN.js';
import '../_common/js/global-config/locale/zh_CN.js';
import '../_chunks/dep-35c2a089.js';
import '../_chunks/dep-fad4e87b.js';
import 'dayjs';
import '../_chunks/dep-81c9c3a2.js';
import '../_common/js/global-config/default-config.js';
import '../common/Portal.js';
import 'react-dom';
import './gradient.js';
import '../hooks/useDomRefCallback.js';
import '../_common/js/loading/circle-adapter.js';
import '../_common/js/utils/setStyle.js';
import '../_common/js/utils/helper.js';
import '../_chunks/dep-ff447334.js';
import '../_chunks/dep-1978af39.js';
import './defaultProps.js';
import '../hooks/useDefaultProps.js';
import '../_util/react-render.js';
import '../_chunks/dep-d1dfa561.js';

var Loading = Loading$1;
var loading = LoadingPlugin$1;
var LoadingPlugin = LoadingPlugin$1;

export { Loading, LoadingPlugin, Loading as default, loading };
//# sourceMappingURL=index.js.map
